export default {
  namespaced  : true,
  state       : {
    isRequireLandscapeProtect     : false,
    loginedView                   : false,
    
    isVisiblePageContent          : false,

    mountedLayoutStyleName        : null,

    mainContentHeight             : null,

    isBodyNoScroll                : false,

    isNoBodyPullToRefreshAndroid  : false,

    isMountedLoginedViewPage      : false,
  },
  
  mutations   : {
    setIsNoBodyPullToRefreshAndroid(state, value){
      state.isNoBodyPullToRefreshAndroid = value;
    },

    setIsBodyNoScroll(state, value){
      state.isBodyNoScroll = value;
    },

    setMainContentHeight(state, value){
      state.mainContentHeight = value;
    },

    setIsRequireLandscapeProtect(state, payload){
      state.isRequireLandscapeProtect = payload;
    },

    setLoginedView(state, value){
      state.loginedView = value;
    },

    setIsVisiblePageContent(state, value){
      state.isVisiblePageContent = value;
    },

    setMountedLayoutStyleName(state, value){
      state.mountedLayoutStyleName = value;
    },

    setIsMountedLoginedViewPage(state, value){
      state.isMountedLoginedViewPage = value;
    }
  },

  actions   : {
    updateIsNoBodyPullToRefreshAndroid(context, payload){
      context.commit('setIsNoBodyPullToRefreshAndroid', payload.value);
    },

    updateIsBodyNoScroll(context, payload){
      context.commit('setIsBodyNoScroll', payload.value);
    },

    updateMainContentHeight(context, payload){
      context.commit('setMainContentHeight', payload.value);
    },

    updateLandscapeProtect(context, payload){
      context.commit('setIsRequireLandscapeProtect', payload);
    },

    updateLoginedView(context, payload){
      context.commit('setLoginedView', payload.value);
    },
    
    updateIsVisiblePageContent(context, payload){
      context.commit('setIsVisiblePageContent', payload.value);
    },

    updateMountedLayoutStyleName(context, payload){
      context.commit('setMountedLayoutStyleName', payload.value);
    },

    updateIsMountedLoginedViewPage(context, payload){
      context.commit('setIsMountedLoginedViewPage', payload.value);
    }
  }
}